import React, { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import { Tile } from '@op/opds.opux';

interface TileContentProps {
  icon: ReactElement<any>;
  msgId: string;
}

const TileContent = ({ icon, msgId }: TileContentProps): ReactElement => {
  return (
    <Tile style={{ width: '260px' }}>
      <div className="investoracademy-vertical-flex-align investoracademy-task-tile-container">
        {icon}
        <p style={{ paddingBottom: '0px', textAlign: 'center' }}>
          <Message id={msgId} />
        </p>
      </div>
    </Tile>
  );
};

export default TileContent;
